import { render, staticRenderFns } from "./ButtonTertiaryAction.vue?vue&type=template&id=3d8141a2&scoped=true&"
import script from "./ButtonTertiaryAction.vue?vue&type=script&lang=js&"
export * from "./ButtonTertiaryAction.vue?vue&type=script&lang=js&"
import style1 from "./ButtonTertiaryAction.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8141a2",
  null
  
)

export default component.exports